import { useState } from "react";

// import { FiTrash } from "react-icons/fi";

// import { FaFire } from "react-icons/fa";
import { CardType } from "./types";
import { Column } from "./column";
import { TodoViewModal } from "./todo-view-modal";

// const DEFAULT_CARDS: CardType[] = [
//   // PENDING
//   {
//     id: "1",
//     title: "Look into render bug in dashboard",
//     description: "Description 1 Hello Hello Hello Hello Hello Hello Hello",
//     column: "Pending",
//   },

//   // STARTED
//   {
//     id: "5",
//     title: "Research DB options for new microservice",
//     description: "Description 5",
//     column: "Started",
//   },

//   // Update Required
//   {
//     id: "8",
//     title: "Refactor context providers to use Zustand",
//     description: "Description 8",
//     column: "Update Required",
//   },

//   // Testing
//   {
//     id: "10",
//     title: "Set up DD dashboards for Lambda listener",
//     description: "Description 10",
//     column: "Testing",
//   },
// ];

export const Board = ({ cardsData }: { cardsData: CardType[] }) => {
  const [cards, setCards] = useState(cardsData);

  return (
    <div className="flex h-full w-full gap-8 overflow-x-scroll p-12">
      <Column
        title="Pending"
        column="Pending"
        headingColor="text-neutral-500"
        cards={cards}
        setCards={setCards}
      />

      <Column
        title="Started"
        column="Started"
        headingColor="text-yellow-500"
        cards={cards}
        setCards={setCards}
      />

      <Column
        title="Update Required"
        column="Update Required"
        headingColor="text-blue-500"
        cards={cards}
        setCards={setCards}
      />

      <Column
        title="Testing"
        column="Testing"
        headingColor="text-emerald-400"
        cards={cards}
        setCards={setCards}
      />
      <Column
        title="Finished"
        column="Finished"
        headingColor="text-green-500"
        cards={cards}
        setCards={setCards}
      />

      {/* <BurnBarrel setCards={setCards} /> */}

      <TodoViewModal />
    </div>
  );
};

// const BurnBarrel = ({
//   setCards,
// }: {
//   setCards: Dispatch<SetStateAction<CardType[]>>;
// }) => {
//   const [active, setActive] = useState(false);

//   const handleDragOver = (e: DragEvent) => {
//     e.preventDefault();

//     setActive(true);
//   };

//   const handleDragLeave = () => {
//     setActive(false);
//   };

//   const handleDragEnd = (e: DragEvent) => {
//     const cardId = e.dataTransfer.getData("cardId");

//     setCards((pv) => pv.filter((c) => c.id !== cardId));

//     setActive(false);
//   };

//   return (
//     <div
//       onDrop={handleDragEnd}
//       onDragOver={handleDragOver}
//       onDragLeave={handleDragLeave}
//       className={`mt-10 grid h-56 w-56 shrink-0 place-content-center rounded border text-3xl ${
//         active
//           ? "border-red-800 bg-red-800/20 text-red-500"
//           : "border-neutral-500 bg-neutral-500/20 text-neutral-500"
//       }`}
//     >
//       {active ? <FaFire className="animate-bounce" /> : <FiTrash />}
//     </div>
//   );
// };

// type AddCardProps = {
//   column: ColumnType;

//   setCards: Dispatch<SetStateAction<CardType[]>>;
// };

// const AddCard = ({ column, setCards }: AddCardProps) => {
//   const [text, setText] = useState("");

//   const [adding, setAdding] = useState(false);

//   const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
//     e.preventDefault();

//     if (!text.trim().length) return;

//     const newCard = {
//       column,

//       title: text.trim(),
//       description: "",

//       id: Math.random().toString(),
//     };

//     setCards((pv) => [...pv, newCard]);

//     setAdding(false);
//   };

//   return (
//     <>
//       {adding ? (
//         <motion.form layout onSubmit={handleSubmit}>
//           <textarea
//             onChange={(e) => setText(e.target.value)}
//             autoFocus
//             placeholder="Add new task..."
//             className="w-full rounded border border-violet-400 bg-violet-400/20 p-3 text-sm text-neutral-50 placeholder-violet-300 focus:outline-0"
//           />

//           <div className="mt-1.5 flex items-center justify-end gap-1.5">
//             <button
//               onClick={() => setAdding(false)}
//               className="px-3 py-1.5 text-xs text-neutral-400 transition-colors hover:text-neutral-50"
//             >
//               Close
//             </button>

//             <button
//               type="submit"
//               className="flex items-center gap-1.5 rounded bg-neutral-50 px-3 py-1.5 text-xs text-neutral-950 transition-colors hover:bg-neutral-300"
//             >
//               <span>Add</span>

//               <FiPlus />
//             </button>
//           </div>
//         </motion.form>
//       ) : (
//         <motion.button
//           layout
//           onClick={() => setAdding(true)}
//           className="flex w-full items-center gap-1.5 px-3 py-1.5 text-xs text-neutral-400 transition-colors hover:text-neutral-50"
//         >
//           <span>Add card</span>

//           <FiPlus />
//         </motion.button>
//       )}
//     </>
//   );
// };
